export default __webpack_public_path__ + "static/media/pink_blur_background.09010336.jpg";